import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import '../../css/common/StudentGroupCard.css';

const StudentGroupCard = ({ group, onClick }) => {
  return (
    <div className="student-group-card-component" onClick={onClick}>
      <div className="student-group-card-content">
        <h3 className="student-group-card-name">{group.name}</h3>
        <div className="student-group-card-contact">
          <FaEnvelope className="student-group-card-email-icon" title={`Contact ${group.contact.name}`} />
        </div>
      </div>
    </div>
  );
};

export default StudentGroupCard; 